import {Component, Input, OnInit} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../constants/common.constants";

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.component.html',
  styleUrls: ['./group-details.component.css']
})
export class GroupDetailsComponent implements OnInit {
  @Input() userDetails;
  @Input() loading;

  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;


  ngOnInit() {
  }
}
